'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextractScoresheetPdfs = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var getTextractScoresheetPdfs = exports.getTextractScoresheetPdfs = function getTextractScoresheetPdfs(feis_id) {
  var textractStatuses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      textractStatuses: textractStatuses

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/textract/all/feiseanna/' + feis_id + '?statuses=' + textractStatuses,
        method: 'GET'
      },
      types: ['GET_TEXTRACT_SCORESHEETS_START', 'GET_TEXTRACT_SCORESHEETS', 'GET_TEXTRACT_SCORESHEETS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/textract/getTextractScoresheets.js
// module id = 685
// module chunks = 0